// Use this for Local Development
export let WEBSITE_URL;
if (process.env.NODE_ENV === "development") {
    WEBSITE_URL = "https://dev.foodrunners.co.nz";
} else {
    WEBSITE_URL = "https://" + window.location.hostname;
}
